import React from 'react';
import styled from 'styled-components';
import { AppVersionCheck } from '@sdir/utilities/lib/components';
import Providers from './components/Providers/Providers';
import Routes from './components/Routes';
import ContentSection from './components/ContentSection';

const baseUrl = process.env.REACT_APP_VERCHECK_URL || window.location.href.split('#')[0];
const versionCheckInterval = process.env.REACT_APP_VERCHECK_INTERVAL
  ? +process.env.REACT_APP_VERCHECK_INTERVAL
  : null;

export const App: React.FC = () => {
  return (
    <Providers>
      {versionCheckInterval && (
        <AppVersionCheck baseUrl={baseUrl} checkIntervalMs={versionCheckInterval} />
      )}
      <Routes ContentSection={ContentSection} />
    </Providers>
  );
};
